module.exports = __webpack_public_path__ + "static/media/backtopmenu-arrow.f87b381f.svg";